// web stub — live location initialization is native-only
export function useInitialiseLiveLocation(_config: {
  isLiveTrackingEnabled: boolean;
  liveTrackingMode?: 'manual' | 'automatic';
  liveTrackingIntervalMs?: number;
  liveTrackingNotificationMessage?: string;
}): void {
  // no-op on web
}
